"use client";

import { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { Toaster } from "react-hot-toast";

const FacebookScripts = dynamic(() => import("@/components/FacebookScript"), { ssr: false });
const GoogleOneTap = dynamic(() => import("@/components/Google/GoogleOneTap"), { ssr: false });
const GDPRConsent = dynamic(() => import("@/components/GDPRConsent"), { ssr: false });
// const LoggingGate = dynamic(() => import("@/components/LoggingGate"), { ssr: false });
const RecaptchaBadgeController = dynamic(() => import("@/components/RecaptchaBadgeController"), { ssr: false });
const OneSignalInit = dynamic(() => import("@/components/OneSignalInit"), { ssr: false });
const GoogleTagManager = dynamic(
  () => import("@next/third-parties/google").then((mod) => mod.GoogleTagManager),
  { ssr: false }
);
const GoogleAnalytics = dynamic(
  () => import("@next/third-parties/google").then((mod) => mod.GoogleAnalytics),
  { ssr: false }
);

export default function DeferredClientFeatures({
  shouldLoadGtm,
  shouldLoadGa,
  shouldLoadFacebook,
  gtmId,
  gaId,
  shouldLoadOneTap,
  oneSignalAppId,
}: {
  shouldLoadGtm: boolean;
  shouldLoadGa: boolean;
  shouldLoadFacebook: boolean;
  gtmId: string;
  gaId: string;
  shouldLoadOneTap: boolean;
  oneSignalAppId: string;
}) {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const enable = () => setEnabled(true);
    if ("requestIdleCallback" in window) {
      const idleId = (window as Window & {
        requestIdleCallback?: (callback: () => void, options?: { timeout: number }) => number;
        cancelIdleCallback?: (id: number) => void;
      }).requestIdleCallback?.(enable, { timeout: 5000 });

      return () => {
        if (typeof idleId === "number") {
          (window as Window & { cancelIdleCallback?: (id: number) => void }).cancelIdleCallback?.(idleId);
        }
      };
    }
    const timer = globalThis.setTimeout(enable, 2500);
    return () => globalThis.clearTimeout(timer);
  }, []);

  if (!enabled) {
    return null;
  }

  return (
    <>
      {shouldLoadGtm && <GoogleTagManager gtmId={gtmId} />}
      {shouldLoadGa && <GoogleAnalytics gaId={gaId} />}
      {shouldLoadFacebook && <FacebookScripts />}
      {shouldLoadOneTap && <GoogleOneTap />}
      {oneSignalAppId && <OneSignalInit appId={oneSignalAppId} />}
      <RecaptchaBadgeController />
      <GDPRConsent />
      {/* <LoggingGate /> */}
      <Toaster position="top-right" />
    </>
  );
}
